<template>
  <section class="search-box" @click.self="closeSearchBox" id="search-box">
    <div class="bg-white search-box-content">
      <SearchContentHeader @close="closeSearchBox" />
      <div class="mt-5">
        <h4 class="title-tages">
          دسته بندی ها
        </h4>

        <nav class="mt-4">
          <ul class="tages-menu">
            <li class="item-tages" v-for="item in categories" :key="item.id">
              <router-link
                :to="{
                  name: 'product.category',
                  params: { category: item.id, slug: item.slug },
                  query: query,
                }"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <productSlider />
    </div>
  </section>
</template>
<script>
import searchIcone from "../icons/search.vue";
import SearchContentHeader from "../../components/searchBox/SearchContentHeader.vue";
import productSlider from "../../components/searchBox/productSlider.vue";
export default {
  components: { searchIcone, SearchContentHeader, productSlider },
  methods: {
    closeSearchBox() {
      this.$emit("setFlage", false);
    },
  },
  watch: {
    $route: {
      handler: function(val) {
        this.$emit("setFlage", false);
      },
    },
  },

  created() {
    if (!this.categories) {
      this.$store.dispatch("front/getMainContent", { route: "get-categories" });
    }
  },
  computed: {
    categories() {
      return this.$store.getters["front/getCategoriesHome"];
    },
  },
};
</script>
<style scoped>
.search-box {
  display: grid;
  place-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  background-color: #00000044;
  z-index: 1000;
  backdrop-filter: blur(5px);
}
.search-box-content {
  width: 1075px;
  background-color: #fff;
  border-radius: 20px;
  padding: 2.5rem;
  max-height: 90vh;
  overflow: auto;
}
.tages-menu {
  display: flex;
  align-items: center;
  list-style-type: none;
  flex-wrap: wrap;
  gap: 1.5rem;
}
.title-tages {
  font-size: 18px;
  font-weight: 800;
}

.item-tages a {
  border: 1px solid var(--gray-e9);
  padding: 4px 20px;
  border-radius: 16px;
  padding-top: 6px;
  font-size: 16px;
  color: gray;
  transition: all 0.3s;
}
.item-tages:hover.item-tages a {
  background-color: #000;
  color: #fff;
  cursor: pointer;
}

@media (max-width: 1400px) {
  .search-box-content {
    width: calc(100vw - 200px);
  }
}
@media (max-width: 639px) {
  .search-box-content {
    height: 80vh;
    width: 85vw;
    padding: 1.5rem;
  }
}</style
>./SearchContentHeader.vue
